<ion-content class="no-tenant-page">
  <div class="nt-wrapper">

    @if (isChecking) {
    <div class="nt-card">
      <ion-spinner name="crescent" color="light"></ion-spinner>
      <p class="nt-body">{{ 'mainauth.noTenant.checking' | translate }}</p>
    </div>
    } @else if (isRedirecting) {
    <div class="nt-card">
      <ion-spinner name="crescent" color="light"></ion-spinner>
      <p class="nt-body">{{ 'mainauth.noTenant.redirecting' | translate }}</p>
    </div>
    } @else if (loadError) {
    <div class="nt-card">
      <div class="nt-icon-ring">
        <ion-icon color="light" name="cloud-offline-outline"></ion-icon>
      </div>
      <h1 class="nt-title">{{ 'mainauth.noTenant.loadErrorTitle' | translate }}</h1>
      <p class="nt-body" role="alert">{{ 'mainauth.noTenant.loadErrorBody' | translate }}</p>
      <button class="nt-logout-btn" (click)="ngOnInit()">
        <ion-icon color="light" name="refresh-outline"></ion-icon>
        {{ 'common.retry' | translate }}
      </button>
      <button class="nt-logout-btn" (click)="logout()">
        <ion-icon color="light" name="log-out-outline"></ion-icon>
        {{ 'mainauth.noTenant.logout' | translate }}
      </button>
    </div>
    } @else {
    <div class="nt-card">

      <div class="nt-icon-ring"
           [appTooltip]="'mainauth.noTenant.tt.organization' | translate"
           tooltipPosition="bottom">
        <ion-icon color="light" name="business-outline"></ion-icon>
      </div>

      <h1 class="nt-title">{{ 'mainauth.noTenant.title' | translate }}</h1>

      <p class="nt-body">
        {{ 'mainauth.noTenant.body' | translate }}
      </p>

      <div class="nt-divider"></div>

      <div class="nt-contact-row">
        <div class="nt-contact-icon">
          <ion-icon color="light" name="mail-outline"></ion-icon>
        </div>
        <div>
          <p class="nt-contact-label">{{ 'mainauth.noTenant.contactSupport' | translate }}</p>
          <a href="mailto:support@gastro-management.ch" class="nt-contact-email"
             [appTooltip]="'mainauth.noTenant.tt.email' | translate">
            support&#64;gastro-management.ch
          </a>
        </div>
      </div>

      <p class="nt-hint">
        {{ 'mainauth.noTenant.hint' | translate }}
      </p>

      <button class="nt-logout-btn" (click)="logout()"
              [appTooltip]="'mainauth.noTenant.tt.logout' | translate">
        <ion-icon color="light" name="log-out-outline"></ion-icon>
        {{ 'mainauth.noTenant.logout' | translate }}
      </button>

    </div>
    }

  </div>
</ion-content>
